import React, { useState } from 'react';
import { FaSearch, FaBell, FaUser, FaEnvelope, FaCog, FaSignOutAlt } from 'react-icons/fa';
import { useLang } from '../i18n/LangContext';
import '../styles/TopBar.css';

const TopBar = ({ pageTitle }) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { t, lang } = useLang();

  const notifications = [
    { id: 1, text: t.topbar.notif1, time: t.topbar.timeAgo1, unread: true },
    { id: 2, text: t.topbar.notif2, time: t.topbar.timeAgo2, unread: true },
    { id: 3, text: t.topbar.notif3, time: t.topbar.timeAgo3, unread: false },
  ];

  const unreadCount = notifications.filter(n => n.unread).length;

  return (
    <header className="topbar">
      <div className="topbar-left">
        <h1 className="page-title">{pageTitle}</h1>
      </div>

      <div className="topbar-center">
        <div className="search-container">
          <FaSearch className="search-icon" />
          <input
            type="text"
            className="search-input"
            placeholder={t.topbar.searchPlaceholder}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      <div className="topbar-right">
        <div className="topbar-actions">
          {/* 알림 */}
          <div className="action-item">
            <button className="action-btn" onClick={() => setShowNotifications(!showNotifications)}>
              <FaBell />
              {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
            </button>
            {showNotifications && (
              <div className="dropdown notification-dropdown">
                <div className="dropdown-header">
                  <h3>{t.topbar.notifications}</h3>
                  <button className="mark-read">{t.topbar.markAllRead}</button>
                </div>
                <div className="notification-list">
                  {notifications.map((notif) => (
                    <div key={notif.id} className={`notification-item ${notif.unread ? 'unread' : ''}`}>
                      <div className="notification-text">{notif.text}</div>
                      <div className="notification-time">{notif.time}</div>
                    </div>
                  ))}
                </div>
                <div className="dropdown-footer">
                  <button className="view-all">{t.topbar.viewAll}</button>
                </div>
              </div>
            )}
          </div>

          {/* 메시지 */}
          <div className="action-item">
            <button className="action-btn"><FaEnvelope /></button>
          </div>

          {/* 사용자 메뉴 */}
          <div className="action-item">
            <button className="user-btn" onClick={() => setShowUserMenu(!showUserMenu)}>
              <div className="user-avatar-small">{lang === 'ko' ? '관' : '管'}</div>
              <span className="user-name-display">{t.sidebar.admin}</span>
            </button>
            {showUserMenu && (
              <div className="dropdown user-dropdown">
                <div className="user-dropdown-header">
                  <div className="user-avatar-large">{lang === 'ko' ? '관' : '管'}</div>
                  <div>
                    <div className="user-dropdown-name">{t.sidebar.admin}</div>
                    <div className="user-dropdown-email">admin@company.com</div>
                  </div>
                </div>
                <div className="dropdown-divider"></div>
                <button className="dropdown-item"><FaUser /> {t.topbar.profile}</button>
                <button className="dropdown-item"><FaCog /> {t.topbar.settings}</button>
                <div className="dropdown-divider"></div>
                <button className="dropdown-item logout"><FaSignOutAlt /> {t.topbar.logout}</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
